












































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Barcode from "../../components/bar-code.vue";
import { mixins } from "vue-class-component";
import AppConsts from "../../../lib/appconst";
import _ from "lodash";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import SerialListModal from "../../components/view-serials-paging.vue";
import SerialInfo from "@/store/entities/products/serial-info";

class PageLineRequest extends PageRequest {
  keyword: string;
  id: number;
}

@Component({
  components: {
    "bar-code": Barcode,
    "serial-modal": SerialListModal,
  },
})
export default class ViewpoReceipt extends mixins(DateTimeMixin, AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  namespace = "poReceipt";
  linepageRequest: PageLineRequest = new PageLineRequest();
  poReceipt: any = null;
  poReceiptLines: Array<any> = new Array<any>();
  linePageList: Array<any> = new Array<any>();
  spinShow: boolean = false;
  code: string = "";
  id: number = 0;
  serialInfo = new SerialInfo();

  serialModalShow: boolean = false;
  get store() {
    return this.$store.state.poReceipt;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  get client() {
    return this.$store.state.session.client;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  hasViewPoPermission() {
    return this.hasPermission(AppConsts.permissionNames.viewPurchaseOrder);
  }
  //============line page =================
  get lineList() {
    var re = this.store.lineList;
    var startIndex = (this.lineCurrentPage - 1) * this.linePageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  get lineLoading() {
    return this.store.lineLoading;
  }
  get linePageSize() {
    return this.store.linePageSize;
  }
  get lineTotalCount() {
    return this.store.lineTotalCount;
  }
  get lineCurrentPage() {
    return this.store.lineCurrentPage;
  }
  refreshLinePageIndex() {
    this.$store.commit(`${this.namespace}/setLineCurrentPage`, 1);
  }
  linePageChange(page: number) {
    this.$store.commit(`${this.namespace}/setLineCurrentPage`, page);
    this.getLinePage();
  }
  linePageSizeChange(pagesize: number) {
    this.$store.commit(`${this.namespace}/setLinePageSize`, pagesize);
    this.getLinePage();
  }
  async searchLineData() {
    this.refreshLinePageIndex();
    await this.getLinePage();
  }
  async getLinePage() {
    this.linepageRequest.id = this.id;
    this.linepageRequest.maxResultCount = this.linePageSize;
    this.linepageRequest.skipCount =
      (this.lineCurrentPage - 1) * this.linePageSize;
    await this.$store
      .dispatch({
        type: `${this.namespace}/getAllLines`,
        data: this.linepageRequest,
      })
      .catch(() => {
        this.store.lineLoading = false;
      });
  }
  //========== serials

  openSerialModal() {
    this.serialModalShow = true;
  }

  closeSerialModal() {
    this.serialModalShow = false;
    this.serialInfo = new SerialInfo();
  }
  showDetail(row) {
    this.serialInfo.qty = row.qty;
    this.serialInfo.sku = row.poLine.poLineProduct.sku;
    this.serialInfo.productName = row.poLine.poLineProduct.name;
    this.serialInfo.productId = row.poLine.productId;
    this.serialInfo.serials = _.map(row.serials, function(item) {
      var serial = {
        serialNo: item,
      };
      return serial;
    });
    this.openSerialModal();
  }
  //======== functions ===========
  async exportToExcel() {
    await this.$store.dispatch({
      type: `${this.namespace}/export`,
      data: { id: this.id },
    });
  }
  cancel() {
    this.$emit("input", false);
    this.$root.$router.push({ name: "po-receipt" });
  }
  async getPoReceipt() {
    await this.$store
      .dispatch({
        type: `${this.namespace}/get`,
        data: { id: this.id },
      })
      .then(async (result) => {
        this.poReceipt = result;
        this.id = this.poReceipt.id;
        this.code = this.poReceipt.code;
        this.searchLineData();
      });
  }

  async created() {
    this.spinShow = true;
    try {
      this.id = +this.$root.$router.currentRoute.params.id;
      await this.getPoReceipt();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }

  get lineColumns() {
    return [
      {
        title: Util.L("Order"),
        key: "orderNo",
        width: 50,
      },
      {
        title: Util.L("BatchCode"),
        width: 150,
        key: "batchCode",
        render: (h: any, params: any) => {
          return h("span", params.row.poLine.batchCode);
        },
      },
      {
        title: Util.L("Sku"),
        width: 150,
        key: "sku",
        render: (h: any, params: any) => {
          return h("span", params.row.poLine.poLineProduct.sku);
        },
      },
      {
        title: Util.L("ProductName"),
        width: 250,
        key: "productName",
        render: (h: any, params: any) => {
          return h("span", params.row.poLine.poLineProduct.name);
        },
      },
      {
        title: Util.L("BrandName"),
        width: 120,
        key: "brandName",
        render: (h: any, params: any) => {
          return h("span", params.row.poLine.brandName);
        },
      },
      {
        title: Util.L("Unit"),
        width: 100,
        key: "unitName",
        render: (h: any, params: any) => {
          return h("span", params.row.poLine.unitName);
        },
      },
      {
        title: `${Util.L("ManufactureMonth")}`,
        key: "manufactureMonth",
        width: 100,
        render: (h: any, params: any) => {
          return h(
            "span",
            Util.toMonthYearString(params.row.poLine.manufactureMonth)
          );
        },
      },
      {
        title: `${Util.L("ReceivedQty")}`,
        key: "qty",
        width: 120,
        align: "right",
        slot: "qty",
      },
      {
        title: `${Util.L("Price")}`,
        key: "price",
        width: 100,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.poLine.price));
        },
      },
      {
        title: `${Util.L("TotalAmount")}`,
        key: "totalAmount",
        width: 100,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.totalAmount));
        },
      },
    ];
  }
}
